import format from 'date-fns/format';
import * as dateFnsLocales from 'date-fns/locale';

const formatDate = (dateString, formatString, intl) => {
  try {
    return format(new Date(dateString), formatString, { locale: intl ? dateFnsLocales[intl] : dateFnsLocales.enUS });
  } catch {
    return dateString;
  }
}

export const formatDateRangeWithMinRepetition = (startDate, endDate) => {
  if (!startDate || !endDate) return null;

  const start = new Date(startDate);
  const end = new Date(endDate);

  const isSameYear = start.getFullYear() === end.getFullYear();
  const isSameMonth = start.getMonth() === end.getMonth();

  const startDateFormatString = (isSameYear && isSameMonth && 'd') || (isSameYear && 'd MMM') || 'd MMM, yyyy';

  const formattedStartDate = formatDate(startDate, startDateFormatString);
  const formattedEndDate = formatDate(endDate, 'd MMM, yyyy');

  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const formatIntlDate = (dateString, languageCode, countryCode) => {
  try {
    const locale = languageCode && countryCode ? `${languageCode}-${countryCode.toUpperCase()}` : 'en-US';
    return new Intl.DateTimeFormat(locale).format(new Date(dateString));
  } catch {
    return dateString;
  }
}

export const getDateFormatForDatePicker = (locale = 'en-US', isSingleDate = false) => {
  const parts = new Intl.DateTimeFormat(locale).formatToParts(new Date());
  const options = new Intl.DateTimeFormat(locale).resolvedOptions();
  return parts.map(part => {
      const {type} = part; 
      switch (type) {
          case 'day':
              if (options[type] === '2-digit') return isSingleDate?'d':'dd';
              if (options[type] === 'numeric') return isSingleDate?'j':'d';
              break;
          case 'month':
              if (options[type] === '2-digit') return isSingleDate?'m':'MM';
              if (options[type] === 'numeric') return isSingleDate?'n':'M';
              break;
          case 'year':
              if (options[type] === 'numeric') return 'Y';
              break;
          case 'literal': return part.value;
          default: return '';
      }
      return '';
  }).join('');
}

export default formatDate;
